import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  TableHeaderCell,
  TakedownTable,
} from '../../pages/ThreadsDetails/Style/SingleThreat.style';
import { SectionColumn, SectionTitle } from '../ThreatTable/ThreatExpandedRow.style';
import { HorizontalLine } from '../../pages/ThreadsDetails/Style/SingleThreat.style';

interface ExpandedDnsRecordsProps {
  filteredDnsRecords: any[] | undefined;
  dnsLoading: boolean;
}

const ExpandedDnsRecords = ({ filteredDnsRecords, dnsLoading }: ExpandedDnsRecordsProps) => {
  const theme = useTheme();

  return (
    <SectionColumn>
      <SectionTitle>DNS Records</SectionTitle>
      <HorizontalLine sx={{ mb: 1 }} />
      {dnsLoading ? (
        <Skeleton variant="rectangular" height={100} />
      ) : filteredDnsRecords && filteredDnsRecords.length > 0 ? (
        <TakedownTable>
          <TableContainer sx={{ maxHeight: 200 }}>
            <Table size="small" sx={{ border: 0 }}>
              <TableHead>
                <TableRow>
                  <TableHeaderCell>Type</TableHeaderCell>
                  <TableHeaderCell>Address</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDnsRecords.map((record: any, index: number) => (
                  <TableRow key={index} sx={{ '&:last-child td': { border: 0 } }}>
                    <TableCell sx={{ fontSize: '12px' }}>{record.record_type}</TableCell>
                    <TableCell sx={{ fontSize: '12px' }}>
                      {record.address || record.server || '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TakedownTable>
      ) : (
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.disabled, fontStyle: 'italic' }}>
          No DNS records
        </Typography>
      )}
    </SectionColumn>
  );
};

export default ExpandedDnsRecords;
